import type { ComponentCommonTitle } from '@edwin-group/people-graphql';
import classNames from 'classnames';

export default function DefaultContentTemplateTitle({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonTitle;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <h1
      key={component.title}
      className={classNames('!font-haffer !text-sh-36-48 !text-dark-grey', className, {
        '!my-0': isDefaultContentTemplate,
        '!my-sh-30': !isDefaultContentTemplate,
      })}>
      {component.title}
    </h1>
  );
}
